import PropTypes from "prop-types";
import Loader from "shared/components/Loader";
import { useQuery } from "shared/hooks/useApi";
import graphql from "utils/api/graphql";
import { INITIAL_VALUES } from "../utils/constants";

const Sources = ({ View, filter, ...props }) => {
  const variables = {
    ...filter,
    baseUrl: process.env.REACT_APP_BASE_URL,
    skip: parseInt(filter.skip) || INITIAL_VALUES.skip,
    take: parseInt(filter.take) || INITIAL_VALUES.take,
  };
  const query = useQuery(graphql.queries.ADMIN_SOURCES, {
    variables,
    fetchPolicy: "cache-and-network",
  });
  const WrappedView = Loader(View);
  return (
    <WrappedView
      {...{
        ...props,
        ...query,
        type: "sources",
      }}
    />
  );
};

Sources.propTypes = {
  View: PropTypes.func.isRequired,
  filter: PropTypes.object,
};

Sources.defaultProps = {
  filter: {},
};

export default Sources;
